<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <Dict slot="collectionType" slot-scope="text" :dict-code="DICT_CODE.COLLECTION_TRADE_NEW_TYPE" :value="text"/>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Bank CardNo.">
          <a-input placeholder="Bank CardNo." v-decorator="['bankCardNo', validatorRules.bankCardNo]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Phone">
          <a-input placeholder="Phone" v-decorator="['phoneNo', validatorRules.phoneNo]" />
        </a-form-item>

<!--        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Wallet type">-->
<!--          <a-input placeholder="Wallet type" v-decorator="['isBankCard', validatorRules.isBankCard]" />-->
<!--        </a-form-item>-->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Wallet Type">
          <dict-select
            v-decorator="['isBankCard', validatorRules.isBankCard]"
            :dict-code="DICT_CODE.COLLECTION_TRADE_NEW_TYPE"
            :placeholder="$t('select')"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Name">
          <a-input placeholder="Name" v-decorator="['names', validatorRules.names]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Surname">
          <a-input placeholder="Surname" v-decorator="['surnames', validatorRules.surnames]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="ID Card">
          <a-input placeholder="ID Card" v-decorator="['curp', validatorRules.curp]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import Dict from '@/views/webpublic/modules/Dict'
import { collectionUserAccountUpdate } from '@/webpublicapi/CollectionAccountInfo'
import DictSelect from '@/views/webpublic/modules/DictSelect'
// duplicateCheck
export default {
  name: 'collectionUserAccountUpdate',
  components: {
    Dict,
    DictSelect,
  },
  data() {
    return {
      title: 'Action',
      visibleCheck: true,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        names: { rules: [{ required: true, message: 'Please fill name' }] },
        surnames: { rules: [{ required: true, message: 'Please fill surname' }] },
        curp: { rules: [{ required: true, message: 'PleaseFillID CardNo.' }] },
        bankCardNo: { rules: [{ required: true, message: 'PleaseFillBank CardNo.' }] },
        phoneNo: { rules: [{ required: true, message: 'PleaseFillPhone' }] },
        isBankCard: { rules: [{ required: true, message: 'Please select wallet type' }] }
      },
    }
  },
  created() {},
  methods: {
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)

      this.visible = true
      const data = pick(this.model, 'names', 'surnames', 'curp', 'bankCardNo', 'phoneNo', 'isBankCard')
      this.$nextTick(() => {
        this.form.setFieldsValue(data)
      })
    },
    onChose(checked) {
      if (checked) {
        this.visibleCheck = true
      } else {
        this.visibleCheck = false
      }
    },
    // Confirm
    handleOk() {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          let obj = collectionUserAccountUpdate(formData)
          obj.then((res) => {
              if (res.code === 1000) {
                that.$message.success(res.msg)
                that.$emit('ok')
              } else {
                that.$message.warning(res.msg)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    // Close
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>
